import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UserExpenseSummaryComponent } from './user-expense-summary/user-expense-summary.component';
import { UserTimesheetSummaryComponent } from './user-timesheet-summary/user-timesheet-summary.component';
import { PersonComponent } from './person/person.component';
import { LoadingSkeletonComponent } from './loading-skeleton/loading-skeleton.component';
import { IonExpenseChipComponent } from './ion-expense-chip/ion-expense-chip.component';
import { EmploymentComponent } from './employment/employment.component';
import { AddressComponent } from './address/address.component';
import { CapitalizePipe } from 'src/app/util/pipes/capitalize.pipe';
//import { CalendarComponent } from './calendar/calendar.component';
//import { MbscModule } from '@mobiscroll/angular';

@NgModule({
  declarations: [
    UserExpenseSummaryComponent,
    UserTimesheetSummaryComponent,
    PersonComponent,
    EmploymentComponent,
    AddressComponent,
    LoadingSkeletonComponent,
    IonExpenseChipComponent,
    CapitalizePipe,
//    CalendarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
//    MbscModule
  ],
  exports: [
    UserExpenseSummaryComponent,
    UserTimesheetSummaryComponent,
    PersonComponent,
    EmploymentComponent,
    AddressComponent,
    LoadingSkeletonComponent,
    IonExpenseChipComponent,
    CapitalizePipe,
//    CalendarComponent
  ]
})
export class MiniComponentsModule {}
